import React from 'react';

import * as styles from './styles';

import { BodyText, ConfirmationModal, ModalType } from '@cobliteam/base-components';

import { Button } from '@cobliteam/ui/components';

import { DeleteRounded } from '@mui/icons-material';

export interface RegistrationButtonGroupProps {
  buttonText: string;
  canSubmit: boolean;
  onCancel: () => void;
  onConfirm: () => void;
  onDelete?: () => void;
}

export const RegistrationButtonGroup: React.FC<RegistrationButtonGroupProps> = ({ buttonText, canSubmit, onCancel, onConfirm, onDelete }) => {
  const [showDeleteConfirmation, setShowDeleteConfirmation] = React.useState(false);

  return (
    <div className={styles.buttonGroup}>
      <Button variant='text' onClick={onCancel}>
        Cancelar
      </Button>

      <Button disabled={!canSubmit} onClick={onConfirm}>
        {buttonText}
      </Button>

      {onDelete && <DeleteRounded className={styles.deleteButton} onClick={() => setShowDeleteConfirmation(true)} />}

      {onDelete && showDeleteConfirmation && (
        <ConfirmationModal open onCancel={() => setShowDeleteConfirmation(false)} onConfirm={onDelete} headerText='Excluir manutenção' buttonText='Excluir' type={ModalType.DELETE}>
          <BodyText>Tem certeza que quer excluir esta manutenção?</BodyText>
          <br />
          <BodyText>Não será possível recuperá-la posteriormente.</BodyText>
        </ConfirmationModal>
      )}
    </div>
  );
};
